import React from "react";

import { PropsWithChildren } from 'react';
import { styled } from '@mui/material';

const StyledMain = styled('main')`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: auto;
  padding: 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
  
  /* 使用块级布局，避免flex居中导致的空白不均 */
  display: block;
  
  /* 平滑滚动 */
  scroll-behavior: smooth;
  
  /* 自定义滚动条 */
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    margin: 4px 0;
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
    border-radius: 6px;
    border: 2px solid transparent;
    background-clip: padding-box;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #1565C0 0%, #0D47A1 100%);
  }
  
  /* 响应式设计 - 优化移动端居中布局 */
  @media (max-width: 1200px) {
    padding: 28px;
  }
  
  @media (max-width: 768px) {
    padding: 16px; /* 减少padding，让内容更靠近边缘 */
    
    /* 移除可能导致空白不均的居中设置 */
    & > * {
      width: 100%;
      max-width: 100%;
    }
  }
  
  @media (max-width: 480px) {
    padding: 12px; /* 进一步减少padding */
    
    /* 超小屏幕优化 */
    & > * {
      width: 100%;
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    }
  }
  
  @media (max-width: 320px) {
    padding: 8px; /* 最小padding */
  }
`;

export const Main = ({ children }: PropsWithChildren<unknown>) => (
  <StyledMain>
    {children}
  </StyledMain>
);
